<template>
  <v-dialog v-model="show" persistent width="800" max-width="800">
    <v-card>
      <v-card-title class="text-h6">
        <v-icon class="mb-0 mr-2" color="warning">
          mdi-help-circle-outline
        </v-icon>
        {{ $t('removeManagerDialog.title') }}
      </v-card-title>
      <v-spacer></v-spacer>
      <v-card-title class="text-h6 ml-5">
        {{
          $t('removeManagerDialog.subtitle1', {
            managerType: isGroup
              ? $t('removeManagerDialog.managerGroup')
              : $t('removeManagerDialog.managerOperator'),
          })
        }}
        <br />
        {{
          $t('removeManagerDialog.subtitle1name', {
            fullname: fullName,
          })
        }}
        <br />
        <br />
        {{ $t('removeManagerDialog.subtitle2') }}
      </v-card-title>

      <v-card-text class="text-h7 mt-2">
        {{ $t('removeManagerDialog.message') }}
      </v-card-text>

      <v-card-actions class="mt-4 justify-start">
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="handleChoice(1)">
          <v-icon dark right> mdi-check </v-icon>
          {{ $t('removeManagerDialog.accept') }}
        </v-btn>

        <v-btn color="error" text @click="handleChoice(2)">
          <v-icon dark left> mdi-close </v-icon
          >{{ $t('removeManagerDialog.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    fullName: String,
    isGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false, // Inicialmente el diálogo está cerrado
    }
  },
  mounted() {
    // Abrimos el diálogo cuando el componente se monta
    this.show = true
  },
  methods: {
    handleChoice(choice) {
      this.$emit('removeManagerChoice', choice == 1 ? 'accept' : 'cancel')
      this.show = false
    },
  },
}
</script>
